import { Icon, IconProps } from '../Icon'

export const GridViewIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      grid_view
    </Icon>
  )
}
